import React from 'react';
import PropTypes from 'prop-types';
import { Grid, Message, Icon, Divider } from 'semantic-ui-react';
import _ from 'lodash';
import NewCampaignForm, { FORM_TYPES } from '../../components/new-campaign-form';
import FacebookAdsManager from '../../components/facebook-ads-manager';
import CampaignGoogleLinkTracking from '../../components/campaign-google-link-tracking';
import CampaignOverviewSettings from '../campaign-overview-settings';
import CampaignScanningSettings from '../campaign-scanning-settings';
import CampaignNegativeKeywordsSettings from '../campaign-negative-keywords-settings';
import CampaignEcommerceSettings from '../../components/campaign-ecommerce-settings';

class CampaignSettings extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      updatedOK: false,
    };
  }

  updateCampaign = async ({
    name,
    budget,
    currency,
    country,
    hashtags,
    liveDate,
    endDate,
    impressionsCPM,
    engagementsCPM,
    ieRatio,
    campaignCode,
    sendChaseEmails,
    brand,
    scanUnauthorisedStories,
    useEstimatedReachAndImpressions,
  }) => {
    const { jsonAPIClient, params: { id: campaignId }, organisation, restClient } = this.props;

    const resource = await jsonAPIClient.get('campaigns', campaignId);
    const currencyValue = _.isNil(currency) ? _.get(organisation, 'defaultCurrency', 'GBP') : currency;

    if (resource.get('campaignType') === 'AUTOMATED') {
      resource.set('budget', budget);
      resource.set('hashtags', hashtags);
      resource.set('currency', currencyValue);
      resource.set('impressionsCPM', impressionsCPM || null);
      resource.set('engagementsCPM', engagementsCPM || null);
      resource.set('ieRatio', ieRatio || null);
      resource.set('sendChaseEmails', sendChaseEmails || false);
      resource.set('country', country || null);
      resource.set('scanUnauthorisedStories', scanUnauthorisedStories || false);
      resource.set('useEstimatedReachAndImpressions', useEstimatedReachAndImpressions || false);

      if (liveDate) {
        resource.set('liveDate', liveDate);
      }
      if (endDate) {
        resource.set('endDate', endDate);
      }
      if (campaignCode) {
        resource.set('campaignCode', campaignCode);
      }
      const safeBrand = _.trim(brand);
      if (brand) {
        resource.set('brand', safeBrand);
      }
    }

    resource.set('name', name);
    await resource.sync();

    const deleteCacheURL = `/organisations/${_.get(organisation, 'id')}/cache`;

    await restClient({
      method: 'DELETE',
      url: deleteCacheURL,
      baseURL: process.env.REACT_APP_CAMPAIGNS_GET_URL,
    });

    this.setState({
      updatedOK: true,
    });

    this.props.onLoadingCampaign(campaignId, true);
  }

  render() {
    const { updatedOK } = this.state;
    const { campaign: campaignJSImmutable, organisation } = this.props;
    const campaign = campaignJSImmutable ? campaignJSImmutable.toJSON() : null;
    const campaignType = _.get(campaign, 'campaignType', null);
    const campaignId = _.get(campaign, 'id', null);
    const campaignOverview = _.get(campaign, 'overview', {});
    const organisationName = _.get(organisation, 'name', null);
    const baseTrackingUrl = _.get(campaign, 'baseTrackingUrl', '');
    const account = _.get(organisation, 'adsManagerAccount', null);

    const overviewSettingsProps = {
      campaignOverview,
    };

    return (
      <Grid divided>
        {
          updatedOK && (
            <Grid.Row>
              <Grid.Column widht="16">
                <Message success icon>
                  <Icon name="check circle" />
                  Campaign has been updated.
                </Message>
              </Grid.Column>
            </Grid.Row>
          )
        }
        <Grid.Row>
          <Grid.Column width="6">
            { campaign && (
              <NewCampaignForm
                inEditMode
                formType={FORM_TYPES.ADVANCED}
                campaignType={campaignType}
                onFormSubmit={this.updateCampaign}
                {...campaign}
              />
            )}
          </Grid.Column>
          <Grid.Column width="10">
            <CampaignScanningSettings campaignId={campaignId} {...overviewSettingsProps} />
            {campaignId && <CampaignNegativeKeywordsSettings campaignId={campaignId} />}
            <CampaignOverviewSettings campaignId={campaignId} {...overviewSettingsProps} />
            <FacebookAdsManager campaignId={campaignId} name={organisationName} account={account} />
            <Divider />
            <CampaignGoogleLinkTracking baseTrackingUrl={baseTrackingUrl} campaignId={campaignId} />
            <CampaignEcommerceSettings campaignId={campaignId} />
          </Grid.Column>
        </Grid.Row>
      </Grid>
    );
  }
}

CampaignSettings.propTypes = {
  campaign: PropTypes.object.isRequired,
  organisation: PropTypes.object.isRequired,
  onLoadingCampaign: PropTypes.func.isRequired,
};

export default CampaignSettings;



/** WEBPACK FOOTER **
 ** ./src/containers/campaign-settings/index.js
 **/